import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { logError } from '../../../utils/logger';

export class ELDErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    logError('ELD module error:', { error, info });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#3D3F42] flex items-center justify-center">
          <div className="bg-[#2A2B2E] p-6 rounded-lg text-center max-w-lg">
            <AlertTriangle className="w-12 h-12 text-red-500 mx-auto mb-4" />
            <h2 className="text-xl font-semibold text-red-500 mb-2">Error Loading ELD Module</h2>
            <p className="text-gray-400 mb-4">{this.state.error?.message || 'Something went wrong'}</p>
            {process.env.NODE_ENV === 'development' && (
              <pre className="text-left text-xs text-gray-500 bg-gray-800 p-4 rounded overflow-auto max-h-40 mb-4">
                {this.state.error?.stack}
              </pre>
            )}
            <button
              onClick={() => window.location.reload()}
              className="px-4 py-2 bg-gray-700 text-white rounded hover:bg-gray-600"
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}